import { useEffect } from 'react'

export const useServiceWorker = () => {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(() => {})
    }
  }, [])
}

export const requestBrowserNotifications = async () => {
  if (!('Notification' in window)) {
    return 'unsupported'
  }

  if (Notification.permission === 'granted') {
    return 'granted'
  }

  return Notification.requestPermission()
}

export const pushBrowserNotification = async (title: string, body: string, url: string) => {
  if (Notification.permission !== 'granted') {
    return
  }

  const registration = await navigator.serviceWorker.getRegistration()

  if (registration) {
    await registration.showNotification(title, {
      body,
      data: { url },
      badge: '/badge.svg',
      icon: '/icon.svg',
    })
    return
  }

  new Notification(title, { body })
}
